import React, { Fragment } from 'react';
import { View } from 'react-native';
import lodashIsEmpty from 'lodash/isEmpty';

import { SelectableBadgeItem } from '../../../../Components/Sheets/DietaryOrCelebration/types';
import themeStyle from '../../../../Theme/styles';

import Pill from './Pill';

const DisplaySelectedSamples = ({
  values,
  EmptyComponent,
}: {
  values: SelectableBadgeItem[];
  EmptyComponent?: React.ReactNode;
}) => {
  if (lodashIsEmpty(values) && !React.isValidElement(EmptyComponent))
    return null;
  return (
    <Fragment>
      {lodashIsEmpty(values) ? (
        EmptyComponent
      ) : (
        <View
          style={[
            themeStyle.flexWrap,
            themeStyle.flexDirectionRowCenter,
            { marginHorizontal: -5 },
          ]}
        >
          {values?.map((value: SelectableBadgeItem) => (
            <View
              key={value.label}
              style={[
                themeStyle.spacingLeftSmall,
                themeStyle.spacingRightSmall,
              ]}
            >
              <Pill
                title={
                  value.count ? `${value.count}× ${value.label}` : value.label
                }
                capitalize
                selected
              />
            </View>
          ))}
        </View>
      )}
    </Fragment>
  );
};

export default DisplaySelectedSamples;
